import { Injectable } from '@angular/core';

@Injectable()
export class CommonStorageService {

  private _commonStorageObject: any;
  private profileObject:any;
  private isAdminUser:boolean;
  constructor() { }

  public getCommonStorageObject(): any {
    return this._commonStorageObject;
  }
  public setCommonStorageObject(value: any) {
    this._commonStorageObject = value;
  }

  public setProfileObject(value:any){
    this.profileObject=value;
  }

  public getProfileObject():any{
    return this.profileObject;
  }

  public setAdminUserStatus(isAdminUser:boolean){
    this.isAdminUser=isAdminUser;
  }
  public getAdminUserStatus(){
    return this.isAdminUser;
  }

}
